import React from "react";
// import { MockupPartnerBanner } from "@mockup/PartnerBanner.mockup";
import Slider from "react-slick";
import Link from "next/link";
import { removeHtmlLegacyFromUrl } from "@utils/query.utils";
import { usePartnerBanner } from "@api/coupon/coupon";
import SkeletonProductGroupBanner from "@components/atoms/skeleton/ui-product-group-banner";

const PartnerCarousel = () => {
  const { data: dataPartnerBanner, isLoading, error } = usePartnerBanner();

  // Previous Button
  function PrevArrow(props: any) {
    const { onClick } = props;
    return (
      <a
        className="carousel-control-prev bg-transparent w-aut"
        role="button"
        data-bs-slide="prev"
        onClick={onClick}
      >
        <span
          className="carousel-control-prev-icon rounded-1"
          aria-hidden="true"
        ></span>
      </a>
    );
  }

  // Next Button
  function NextArrow(props: any) {
    const { onClick } = props;
    return (
      <a
        className="carousel-control-next bg-transparent w-aut"
        role="button"
        data-bs-slide="next"
        onClick={onClick}
      >
        <span
          className="carousel-control-next-icon rounded-1"
          aria-hidden="true"
        ></span>
      </a>
    );
  }

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      {isLoading ? (
        <div className="container-fluid mt-2">
          <section className="product-section partner-banner px-3 px-lg-5 py-3 bg-white rounded-2 ">
            <SkeletonProductGroupBanner />
          </section>
        </div>
      ) : dataPartnerBanner && dataPartnerBanner.banner_partner.length > 0 ? (
        <div className="container-fluid mt-2">
          <section className="product-section partner-banner px-3 py-3 bg-white rounded-2">
            <div>
            <h4 className="title-cms p-3 text-red">สิทธิพิเศษจากพาร์ทเนอร์</h4>
            </div>

            <Slider {...settings}>
              {dataPartnerBanner.banner_partner.map((item, idx) => {
                return (
                  <Link href={item.link} key={idx}>
                    <a className="card p-1 mx-2" target="_blank">
                      <img
                        className="card-image rounded-2"
                        src={item.image}
                        alt={item.title}
                      />
                    </a>
                  </Link>
                );
              })}
            </Slider>
          </section>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default PartnerCarousel;
